import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent, LoginComponent } from './components';
import { AssignmentsComponent } from './components/assignments/assignments.component';
import { CrediserverConfigurationComponent } from './components/crediserver-configuration/crediserver-configuration.component';
import { CrediserverComponent } from './components/crediserver/crediserver.component';
import { GenerateTemplateComponent } from './components/generate-template/generate-template.component';
import { LegalTemplatesComponent } from './components/legal-templates/legal-templates.component';
import { PersonCardsComponent } from './components/person-cards/person-cards.component';
import { UsersComponent } from './components/users/users.component';
import { ViewTemplateDocumentsComponent } from './components/view-template-documents/view-template-documents.component';
import { AuthorizationGuard } from './guards/authorization.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: 'login', component: LoginComponent },
  { path: 'home', component: HomeComponent, canActivate: [AuthorizationGuard]},
  { path: 'users', component: UsersComponent, canActivate: [AuthorizationGuard]},
  { path: 'assignments', component: AssignmentsComponent, canActivate: [AuthorizationGuard]},
  { path: 'legal-templates', component: LegalTemplatesComponent, canActivate: [AuthorizationGuard]},
  { path: 'legal-templates/:type', component: GenerateTemplateComponent, canActivate: [AuthorizationGuard]},
  { path: 'legal-templates/:type/:template', component: GenerateTemplateComponent, canActivate: [AuthorizationGuard]},
  { path: 'view-templates', component: ViewTemplateDocumentsComponent, canActivate: [AuthorizationGuard]},
  { path: 'people', component: CrediserverComponent, canActivate: [AuthorizationGuard]},
  { path: 'general', component: CrediserverConfigurationComponent, canActivate: [AuthorizationGuard]},
  { path: 'person-cards', component: PersonCardsComponent, canActivate: [AuthorizationGuard]},
  { path: 'generate-template', component: GenerateTemplateComponent, canActivate: [AuthorizationGuard]},
  { path: '**', pathMatch: 'full', redirectTo: 'home'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
